module.exports = __webpack_public_path__ + "static/media/save.6397f912.svg";